/**
 * ROUND8: what the operations order says about dog teams (docs/milestones/ROUND8-dogs.md, "Legibility": a
 * rule the player cannot see is a bug). Every claim is read off the sim's own numbers (`DOGS`, `RANGER`,
 * `STEALTH`), so the order stays true when the tuning moves. Pure.
 */

import { RANGER } from '../../../sim/tuning';
import { DOGS } from '../../../sim/tuningDogs';
import { STEALTH } from '../../../sim/tuningStealth';

const COUNT = ['NO', 'ONE', 'TWO', 'THREE', 'FOUR'] as const;

/** The EXECUTION line for a mission with `teams` dog teams on it; null when it has none. */
export function dogTeamsLine(teams: number, arctic = false): string | null {
  const n = Math.max(0, Math.floor(teams));
  if (n === 0) return null;
  const who = n === 1 ? 'A HANDLER AND HIS TRACKER DOG WORK' : `${COUNT[n] ?? n} HANDLERS AND THEIR TRACKER DOGS WORK`;
  const parts = [
    `DOG TEAMS: ${who} THE APPROACHES. A DOG FOLLOWS YOUR TRAIL FOR ${DOGS.trailSeconds} SECONDS AFTER YOU LEAVE IT,`
      + ' ON ANY GROUND AND DOWN INTO A TRENCH, AND BARKS ITS HANDLER ON TO YOU. '
      // Arctic rivers are ice, and the trail runs straight across ice: only open water breaks it.
      + (arctic ? 'OPEN WATER BREAKS THE TRAIL; ICE DOES NOT.' : 'WATER BREAKS THE TRAIL.'),
    `IT SMELLS YOU OUT TO ${DOGS.noseRadius} M, FURTHER WHEN THE WIND CARRIES YOUR SCENT TO IT: STAY DOWNWIND OF IT.`,
  ];
  // "You can outrun a dog; you cannot out-creep one" (ROUND8-dogs.md) - said only while the numbers make it so.
  const outrun = RANGER.runSpeed > DOGS.trackSpeed;
  const outcreep = Math.max(RANGER.crawlSpeed, STEALTH.sneakSpeed) >= DOGS.trackSpeed;
  if (outrun && !outcreep) parts.push('YOU CAN OUTRUN A DOG; YOU CANNOT OUT-CREEP ONE.');
  parts.push('IT NEVER BITES.');
  return parts.join(' ');
}
